import { Component, Prop, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '@/app/modules/shared/components/forms/inputs/abstract-field/abstract-field';
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/en';
import 'vue2-datepicker/locale/nl';
import 'vue2-datepicker/locale/fr';
import 'vue2-datepicker/locale/es';
@Component({
  name: 'bpc-date-range',
  components: {
    'bpc-field-wrapper': FieldWrapper,
    'date-picker': DatePicker,
  },
})
export default class DateRange extends mixins(AbstractField) {
  @Prop({
    type: Object,
    default() {
      return {
        start_date: null,
        end_date: null,
      };
    },
  })
  readonly value: { start_date: string; end_date: string };
  @Prop({ type: Boolean, default: true }) readonly showWeeksSelected: boolean;

  startDate: Date = new Date();
  endDate: Date = new Date();

  mounted() {
    this.startDate =
      this.value && this.value.start_date ? moment(this.value.start_date).toDate() : null;
    this.endDate = this.value && this.value.end_date ? moment(this.value.end_date).toDate() : null;
  }

  get valueStartDate() {
    return this.value?.start_date;
  }

  get valueEndDate() {
    return this.value?.end_date;
  }

  get model(): { start_date: string; end_date: string } {
    return {
      start_date: this.startDate ? moment(this.startDate).format('YYYY-MM-DD') : null,
      end_date: this.endDate ? moment(this.endDate).format('YYYY-MM-DD') : null,
    };
  }

  get weeks(): number {
    if (this.model.start_date && this.model.end_date) {
      const startDate = moment(this.model.start_date);
      const endDate = moment(this.model.end_date);
      return endDate.diff(startDate, 'weeks');
    }
    return 0;
  }

  modelChanged() {
    this.$emit('input', this.model);
    if (this.eventsConfig && this.eventsConfig.emit) {
      this.eventsConfig.emit.forEach(event => {
        this.$root.$emit(event, this.model);
      });
    }
  }

  valueChanged() {
    this.startDate =
      this.value && this.value.start_date ? moment(this.value.start_date).toDate() : null;
    this.endDate = this.value && this.value.end_date ? moment(this.value.end_date).toDate() : null;
  }

  extendHandleEvent(eventName: string, event: any, val: any) {
    if (event?.action === 'setDatesFromBookingForm') {
      this.startDate = val?.start_date ? moment(val.start_date).toDate() : null;
      this.endDate = val?.end_date ? moment(val.end_date).toDate() : null;
    }
  }

  @Watch('startDate')
  onStartDateChange() {
    this.modelChanged();
  }
  @Watch('valueStartDate')
  onValueStartDate() {
    this.valueChanged();
  }
  @Watch('valueEndDate')
  onValueEndDateChange() {
    this.valueChanged();
  }

  @Watch('endDate')
  onEndDateChange() {
    this.modelChanged();
  }
}
